import { Common } from '@stockbit/ui';
import Image from 'global/Image';
import { ButtonTrading } from './styled';

const { Flex, Iconmoon, IconWrapper, Text } = Common;

interface ButtonTradingOutlineProps {
  isActive: boolean;
  minimize: boolean;
  label: string;
  imageSrc: string;
  onChangeVisibility?: (active: boolean) => void;
}

const ButtonTradingOutline = ({
  isActive,
  minimize,
  label,
  imageSrc,
  onChangeVisibility,
}: ButtonTradingOutlineProps) => (
  <ButtonTrading
    data-cy="real-trading-btn"
    isActive={isActive}
    minimize={minimize}
    onClick={() => onChangeVisibility(!isActive)}
  >
    <IconWrapper size={minimize ? '20px' : '40px'}>
      <Image src={imageSrc} alt="" style={{ width: '100%' }} />
    </IconWrapper>
    <Flex align="space-between">
      <Text size="13px">{label}</Text>
      <IconWrapper size="16px">
        <Iconmoon className="icon-toolbar_down" />
      </IconWrapper>
    </Flex>
  </ButtonTrading>
);

export default ButtonTradingOutline;
